import React from "react";
import Logo from "../assets/image/Logo.png";

const Footur = () => {
  return (
    <div className="w-full  z-50">
      <footer
        className="text-white py-4 w-full"
        style={{ backgroundColor: "white", color: "black" }} // Background color
      >
        <div className="container mx-auto flex flex-col md:flex-row justify-between px-4 md:px-8">
          {/* Left Section */}
          <div className="flex flex-col md:w-1/4 text-left mb-8 md:mb-0">
            <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-3">
              <img
                src={Logo}
                style={{ width: "12rem", height: "4rem", cursor: "pointer" }}
                alt="Logo"
              />
            </h1>
            <p className="text-xs sm:text-sm md:text-base lg:text-lg text-[#6A9991] max-w-[90%] sm:max-w-full text-center sm:text-left lg:whitespace-nowrap break-words">
              LeadGenPro: Simplifying motor insurance while empowering you to
              earn.
            </p>

            {/*     <div className='flex space-x-4 mt-8 text-[#1C91FF]'>
               Social Media Icons 
              <a
                href='https://facebook.com'
                target='_blank'
                rel='noreferrer'
              >
                <i className='fab fa-facebook text-lg sm:text-xl'></i>
              </a>
              <a
                href='https://twitter.com'
                target='_blank'
                rel='noreferrer'
              >
                <i className='fab fa-twitter text-lg sm:text-xl'></i>
              </a>
              <a
                href='https://instagram.com'
                target='_blank'
                rel='noreferrer'
              >
                <i className='fab fa-instagram text-lg sm:text-xl'></i>
              </a>
            </div>
          </div>
          */}
          </div>
          {/* Right Section */}
          <div className="flex flex-col md:flex-row gap-x-10 text-right">
            {/* Pages Section 
            <div className='md:w-auto'>
              <h3 className='text-sm sm:text-base md:text-lg font-bold mb-2 text-[#1C91FF]'>
                Pages
              </h3>
              <ul>
                <li>
                  <a
                    href='/support'
                    className='text-xs sm:text-sm md:text-base hover:underline text-[#6A9991]'
                  >
                    Support
                  </a>
                </li>
                {/* <li>
                  <a href="/category" className="text-xs sm:text-sm md:text-base hover:underline">
                    Category
                  </a>
                </li> *
                <li>
                  <a
                    href='/'
                    className='text-xs sm:text-sm md:text-base hover:underline text-[#6A9991]'
                  >
                    Article
                  </a>
                </li>
              </ul>
            </div>
            */}
            {/* Service Section */}
            <div className="md:w-auto">
              <h3 className="text-sm sm:text-base md:text-lg font-bold mb-2 text-[#1C91FF]">
                Service
              </h3>
              <ul>
                <li>
                  <a
                    href="/quotation"
                    className="text-xs sm:text-sm md:text-base hover:underline text-[#6A9991]"
                  >
                    Bike insurance
                  </a>
                </li>
                <li>
                  <a
                    href="/quotation"
                    className="text-xs sm:text-sm md:text-base hover:underline text-[#6A9991]"
                  >
                    Car insurance
                  </a>
                </li>
                <li>
                  <a
                    href="/quotation"
                    className="text-xs sm:text-sm md:text-base hover:underline text-[#6A9991]"
                  >
                    Commercial vehicle <br />
                    insurance
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Section */}
            <div className="md:w-auto">
              <h3 className="text-sm sm:text-base md:text-lg font-bold mb-2 text-[#1C91FF]">
                Contact
              </h3>
              <ul>
                <li>
                  <a
                    href="tel:000-000-000"
                    className="text-xs sm:text-sm md:text-base hover:underline text-[#6A9991]"
                  >
                    <i className="fas fa-phone-alt mr-2 text-lg sm:text-xl -scale-x-100 "></i>
                    +91 8858163501 || +91 8858872657
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:Support@leadgenpro.co.in"
                    className="text-xs sm:text-sm md:text-base hover:underline text-[#6A9991]"
                  >
                    <i className="fas fa-envelope mr-2 text-lg sm:text-xl  "></i>
                    support@leadgenpro.co.in
                  </a>
                </li>
                <li>
                  <a
                    href="https://maps.google.com/?q=0000+Lörem+ipsum+St,+City,+Country"
                    className="text-xs sm:text-sm md:text-base hover:underline text-[#6A9991]"
                  >
                    <i className="fas fa-map-marker-alt mr-2 text-lg sm:text-xl"></i>
                    Tista, Kalimpong, West Bengal
                    <br />
                    India
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footur;
